import React from "react";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "./AnimateProgressProvider";

export default function Index(props) {

    const color = props.color || '#ffffff';

    const styles= buildStyles({
                                   textSize: '24px',
                                   pathTransition: "none",

        textColor: color,
        trailColor: `rgba(255, 255, 255, .05)`,
        pathColor: color,
        strokeLinecap: 'butt',
        });

    const classNames = ['disable-fade-in', 'circle-progress__container'];
    if(props.className)
        classNames.push(props.className);

    if (!props.progress) {
        return null;
    }


    return (
        <div  className={classNames.join(' ')}>
            <AnimatedProgressProvider
                valueStart={0}
                valueEnd={props.progress[0]}
                duration={1.4}
                easingFunction={easeQuadInOut}
                repeat={false}
            >
                {value => {
                    return (
                        <CircularProgressbar
                            value={value}
                            strokeWidth={10}
                            text={`${props.progress[1]}`}
                            styles={styles}
                        />
                    );
                }}
            </AnimatedProgressProvider>
            <p className={'circle-progress__title'}>{props.title}</p>
            {props.description ? <p className={'circle-progress__description'}>{props.description}</p> : null}
        </div>

    )
}